// extracted by mini-css-extract-plugin
module.exports = {"form":"_2eBCI","inputWrapper":"_1d_UY","input":"_30y17","searchButton":"_3XESm","searchInlineElement":"_2R_th","noBorder":"_3eoRa"};